import { ModuleLogger, sharedConsoleDestination, LogLevel } from '@hotstar/logger';
import type { LogData } from '@hotstar/logger';

type LogParams = {
  message: string;
  data?: LogData;
  moduleName?: string;
  category?: string;
};

const getConsoleDestInstance = () => sharedConsoleDestination;

const createLogger = (level: LogLevel) => (params: LogParams) => {
  getConsoleDestInstance().handle({
    ...params,
    level,
    moduleName: params.moduleName || 'Unknown Module',
    category: params.category || 'General'
  });
};

const logInfoMessage = createLogger(LogLevel.INFO);
const logErrorMessage = createLogger(LogLevel.ERROR);
const logCriticalMessage = createLogger(LogLevel.CRITICAL);
const logWarnMessage = createLogger(LogLevel.WARN);
const logDebugMessage = createLogger(LogLevel.DEBUG);

if (typeof window !== 'undefined') {
  window.logInfoMessage = logInfoMessage;
  window.logWarnMessage = logWarnMessage;
  window.logErrorMessage = logErrorMessage;
}

const AppLogger = new ModuleLogger(
  {
    moduleName: 'App Logger',
    category: 'app-logger'
  },
  [getConsoleDestInstance()]
);

export {
  ModuleLogger,
  getConsoleDestInstance,
  AppLogger,
  LogLevel,
  logInfoMessage,
  logErrorMessage,
  logCriticalMessage,
  logWarnMessage,
  logDebugMessage
};
export type { LogData };
